import React from "react";

const CholaGreens: React.FC = () => {
  const proximities = [
    { name: "Punnainallur Temple", dist: "0.5 km" },
    { name: "Thanjavur Big Temple", dist: "7 km" },
    { name: "Railway Station", dist: "7 km" },
    { name: "Kumbakonam", dist: "35 km" },
    { name: "Trichy Airport", dist: "60 km" },
  ];

  return (
    <div className="min-h-screen bg-emerald-50 pt-[160px]">
      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-b from-emerald-300 via-emerald-200 to-emerald-100 text-emerald-800">
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-emerald-800">
            CHOLA GREENS
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto mb-8 text-emerald-700">
            More than just land, it's a lifestyle
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a
              href="tel:+917358432777"
              className="bg-emerald-600 hover:bg-emerald-700 text-white font-medium py-3 px-6 rounded-lg transition-colors duration-200"
            >
              Call Now
            </a>
            <a
              href="mailto:sales@cholarealtors.com"
              className="bg-white hover:bg-emerald-50 text-emerald-700 font-medium py-3 px-6 rounded-lg border border-emerald-300 transition-colors duration-200"
            >
              Enquire via Email
            </a>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="py-16 relative overflow-hidden bg-white">
        <div className="absolute inset-0 pointer-events-none" aria-hidden>
          <div className="absolute -top-32 -right-20 w-96 h-96 rounded-full bg-emerald-200 blur-3xl opacity-40" />
          <div className="absolute -bottom-32 -left-20 w-[28rem] h-[28rem] rounded-full bg-emerald-100 blur-3xl opacity-60" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-emerald-800">
            Project Overview
          </h2>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            <div className="lg:col-span-2">
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Chola Greens is a premium residential plot project located in
                the cultural heart of Tamil Nadu, Thanjavur. Surrounded by lush
                greenery and designed with modern amenities, Chola Greens offers
                the perfect balance of natural beauty and urban convenience.
              </p>
              <p className="text-gray-700 text-lg leading-relaxed">
                Each plot is meticulously planned to provide residents with a
                serene environment while ensuring easy access to essential
                facilities. With DTCP Approval and RERA Registration, Chola
                Greens represents a secure investment opportunity with clear
                titles and all necessary permissions.
              </p>
            </div>

            <div className="bg-emerald-50 rounded-xl p-6 shadow-md border border-emerald-100">
              <h3 className="text-xl font-semibold mb-4 text-emerald-700">
                Quick Facts
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-emerald-500 mr-2 mt-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Project Area: 25 Acres</span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-emerald-500 mr-2 mt-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Plot Sizes: 1200-2400 sq ft</span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-emerald-500 mr-2 mt-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>DTCP Approved</span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-emerald-500 mr-2 mt-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>RERA Registered</span>
                </li>
                <li className="flex items-start">
                  <svg
                    className="w-5 h-5 text-emerald-500 mr-2 mt-1"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Clear Title</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features Section */}
      <section className="py-16 bg-emerald-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-emerald-800">
            Key Features
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Feature 1 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Wide Black Top Roads
              </h3>
              <p className="text-gray-600">
                Smooth, durable internal roads for easy access.
              </p>
              <p className="text-gray-600">சிறந்த தரம் கொண்ட அகலமான சாலைகள்</p>
            </div>

            {/* Feature 2 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Street Lights
              </h3>
              <p className="text-gray-600">
                Well-lit avenues for safety at night.
              </p>
              <p className="text-gray-600">தெரு விளக்குகள்</p>
            </div>

            {/* Feature 3 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Underground Drainage
              </h3>
              <p className="text-gray-600">
                Modern concealed drainage network.
              </p>
              <p className="text-gray-600">நவீன மறைக்கப்பட்ட வடிகால் அமைப்பு</p>
            </div>

            {/* Feature 4 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Individual Water Connection
              </h3>
              <p className="text-gray-600">
                Provisioned water points for every plot.
              </p>
              <p className="text-gray-600">
                ஒவ்வொரு மனைக்கும் தனி குடிநீர் இணைப்பு
              </p>
            </div>

            {/* Feature 5 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Gated Community
              </h3>
              <p className="text-gray-600">
                Secure entry with defined boundaries.
              </p>
              <p className="text-gray-600">பாதுகாப்பான நுழைவு வாயில்</p>
            </div>

            {/* Feature 6 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Best Air Quality & Green Environment
              </h3>
              <p className="text-gray-600">
                Live close to nature with plenty of trees.
              </p>
              <p className="text-gray-600">
                சிறந்த காற்று தரம் மற்றும் பசுமையான சூழல்
              </p>
            </div>

            {/* Feature 7 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Abundant Groundwater
              </h3>
              <p className="text-gray-600">
                Reliable water table in the region.
              </p>
              <p className="text-gray-600">நிலத்தடி நீர் நிறைந்த பகுதி</p>
            </div>

            {/* Feature 8 */}
            <div className="bg-white rounded-xl p-6 shadow-md text-center hover:shadow-xl transition-shadow duration-300 border border-emerald-100">
              <div className="bg-emerald-50 p-4 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4">
                <svg
                  className="w-8 h-8 text-emerald-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z"
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2 text-emerald-700">
                Pleasant Climate
              </h3>
              <p className="text-gray-600">
                Comfortable weather throughout the year.
              </p>
              <p className="text-gray-600">ஆண்டு முழுவதும் இதமான காலநிலை</p>
            </div>
          </div>
        </div>
      </section>

      {/* Location & Proximities */}
      <section className="py-12 bg-gradient-to-b from-white to-emerald-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid lg:grid-cols-2 gap-8 items-start">
            <div>
              <h2 className="text-2xl font-semibold text-emerald-900">
                Location Advantage
              </h2>
              <p className="mt-3 text-slate-700">
                Well-connected to religious landmarks, transit hubs, and nearby
                towns.
              </p>
              <ul className="mt-5 grid gap-2">
                {proximities.map((p, i) => (
                  <li
                    key={i}
                    className="flex items-center justify-between bg-white border border-emerald-100 rounded-xl px-4 py-3 shadow-sm hover:shadow-md transition-shadow duration-300"
                  >
                    <span className="font-medium text-slate-800">{p.name}</span>
                    <span className="text-emerald-700 font-semibold">
                      {p.dist}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <div className="aspect-[4/3] w-full rounded-2xl overflow-hidden border border-emerald-100 shadow-sm bg-white">
                {/* Replace the src URL with your actual Google Maps embed link */}
                <iframe
                  title="Chola Greens Map"
                  src="https://www.google.com/maps?q=Punnainallur%2C%20Thanjavur&output=embed"
                  className="w-full h-full"
                  loading="lazy"
                />
              </div>
              <p className="text-xs text-slate-500 mt-2 text-center">
                "*Update the map to the exact project coordinates when
                available."
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CholaGreens;
